import { FunctionComponent } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import { useTranslation } from 'react-i18next'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { useMutation } from '@apollo/client'
import { Close, Delete } from '@mui/icons-material'
import styles from './revokeTokenAndValidDeleteClient.module.scss'
import { useNotification } from '@/modules/context/NotificationContext.tsx'
import { DELETE_API_CLIENT } from '@/modules/API/apiClient/apiClientHandler.ts'

interface ValidDeleteClientApiProps {
    open: boolean
    handleClose: () => void
    id: number
    name: string
    backToList: () => void
}

const ValidDeleteClientApiDialog: FunctionComponent<ValidDeleteClientApiProps> = ({
    open,
    handleClose,
    id,
    name,
    backToList
}: ValidDeleteClientApiProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [deleteOneApiClient] = useMutation(DELETE_API_CLIENT, {
        variables: {
            id: id
        },
        onCompleted: () => {
            showNotificationSuccess(t('apiClientDeleted'))

            backToList()
            handleClose()
        },
        onError: () => {
            showNotificationError(t('errorDeletedApiClient'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose} className={styles.Dialog}>
            <DialogHeader title={t('confirmApiClient')} />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('confirmDeleteApiClientMessage')}</p>
                <p className={styles.Informations}>
                    {name} #{id}
                </p>
                <p className={styles.Text}>{t('noRollBack')}</p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Delete />}
                        onClick={deleteOneApiClient}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ValidDeleteClientApiDialog
